import { render, staticRenderFns } from "./QuizForm.vue?vue&type=template&id=ee256dac"
import script from "./QuizForm.vue?vue&type=script&lang=ts"
export * from "./QuizForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports